const MagistratMandataireStyle = {
  bg: "white",
  borderRadius: "6px",
  flexWrap: "wrap",
  mt: "6",
  overFlow: "hidden",
  p: "3",
  position: "relative",
  width: "100%",
};

const MagistratMainMandataireStyle = {
  flexBasis: 0,
  flexGrow: 99999,
  minWidth: 320,
  pt: 5,
  px: 4,
};

const MagistratSideMandataireStyle = {
  bg: "white",
  borderRadius: "6px",
  flexBasis: 380,
  flexGrow: 1,
  minHeight: "320px",
};

const MagistratTitleMandataireStyle = {
  color: "textSecondary",
  fontFamily: "heading",
  fontSize: 0,
  mb: "4px",
};

const MagistratContentMandataireStyle = {
  color: "text",
  fontFamily: "body",
  fontSize: 1,
  fontWeight: "600",
  mb: 4,
};

const MagistratTribunal = {
  color: "text",
  fontFamily: "body",
  fontSize: 1,
  fontWeight: "600",
  mb: "5px",
};

const boxStyle = {
  flexGrow: 1,
};

const topTextStyle = {
  color: "mediumGray",
  fontWeight: "600",
  mt: "2",
};

const MagistratAntennesStyle = {
  bg: "white",
  borderRadius: "6px",
  flexBasis: 0,
  flexGrow: 99999,
  minWidth: 320,
  mt: "6",
  pt: 5,
  px: 4,
};

export {
  MagistratMandataireStyle,
  MagistratMainMandataireStyle,
  MagistratSideMandataireStyle,
  MagistratTitleMandataireStyle,
  MagistratContentMandataireStyle,
  topTextStyle,
  boxStyle,
  MagistratAntennesStyle,
  MagistratTribunal,
};
